export default function Footer() {
  return (
    <footer className="bg-[#faf8f5] border-t border-[#e8dfc8] py-12 px-5 sm:px-8 lg:px-16">
      <div className="max-w-5xl mx-auto">

        {/* Top */}
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-8 mb-10">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-bold text-[#1a1a1a] mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>
              Dra. Leonida Hendges Fontoura
            </h3>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-building-4-line text-[#C9A84C] text-sm"></i>
              </div>
              <span className="text-[#999] text-xs" style={{ fontFamily: 'DM Sans, sans-serif' }}>Clínica Floratta · RS e SC</span>
            </div>
          </div>

          {/* Social */}
          <div className="flex items-center gap-3">
            <a
              href="https://www.instagram.com/leo_dra_bumbum/"
              className="w-10 h-10 flex items-center justify-center rounded-full border border-[#e8dfc8] text-[#999] hover:border-[#C9A84C] hover:text-[#C9A84C] hover:bg-[#fdf9f0] transition-all duration-300 cursor-pointer"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-base"></i>
            </a>
            <a
              href="https://www.facebook.com/leonida.hendgesfontoura"
              className="w-10 h-10 flex items-center justify-center rounded-full border border-[#e8dfc8] text-[#999] hover:border-[#C9A84C] hover:text-[#C9A84C] hover:bg-[#fdf9f0] transition-all duration-300 cursor-pointer"
              aria-label="Facebook"
            >
              <i className="ri-facebook-circle-line text-base"></i>
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-[#e8dfc8] mb-6"></div>

        {/* Bottom */}
        <p className="text-[#ccc] text-xs text-center" style={{ fontFamily: 'DM Sans, sans-serif' }}>
          © 2026 Dra. Leonida Fontoura. Todos os direitos reservados.
        </p>
      </div>
      <div className="flex items-center justify-center gap-2">
        <p className="text-[#ccc] text-xs text-center" style={{ fontFamily: 'DM Sans, sans-serif' }}>
          Desenvolvido por
        </p>
        <a href="https://camaleal.com.br" target="_blank" rel="noopener noreferrer">
          <img src="/img/cama.png" alt="Camaleal" className="w-8 h-4" />
        </a>
      </div>
    </footer>
  );
}
